import styled from 'styled-components';

export const Wrapper = styled.section`
  /* White like the hero's tilted shape under it, so the slanted edge runs into the
     demo without a coloured wedge. The top padding is small because that shape
     already leaves room under the hero. */
  padding: 24px 0 88px;
  background: #fff;

  @media (max-width: 990px) {
    padding: 24px 0 64px;
  }
  @media (max-width: 767px) {
    padding: 16px 0 48px;
  }
`;

export const Intro = styled.div`
  max-width: 760px;
  margin: 0 auto 40px;
  text-align: center;

  > span {
    display: block;
    margin-bottom: 8px;
    color: #46679f;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.15em;
  }

  h2 {
    margin: 0 0 16px;
    color: #0f2137;
    font-size: 30px;
    font-weight: 700;
    line-height: 1.25;
    letter-spacing: -0.03em;
  }

  p {
    margin: 0;
    color: #5d646d;
    font-size: 17px;
    line-height: 1.75;
  }

  @media (max-width: 767px) {
    margin-bottom: 28px;
    h2 {
      font-size: 24px;
    }
    p {
      font-size: 16px;
    }
  }
`;
